import React from 'react'
import PropTypes from 'prop-types'
import { useLocation, useNavigate } from 'react-router-dom'
import s from './styles.module.scss'
import images from 'images'

import { useRef, useState } from 'react'
import { Alert, ImageTag, Modal } from 'components'
import * as api from 'api'
import { Encrypt } from 'helpers'
import { useSelector } from 'react-redux'
import { getAuthUserData } from 'utils/authManager'

const AdCard = React.memo(function AdCard({
  id,
  title,
  image,
  address,
  adInfo,
  businessName,
  phoneNo,
  isAdmin,
  views = 0,
  status,
  isActive,
  isApproved,
  leads = 0,
  postedOn,
  fkUserId,
  fkBusinessId,
  rejectionMessage,
  deleteHandler,
  engagementType
}) {
  const [adStatus, setAdStatus] = useState(isActive)
  const [adStatusInfo, setAdStatusInfo] = useState(status)
  const processing = useRef(false)
  const location = useSelector(state => state.location).location
  const userData = getAuthUserData()
  const navigate = useNavigate()
  const urlLocation = useLocation()

  const statusHandler = async () => {
    if (processing.current) return
    processing.current = true

    const toggleListingStatus = await api.userAdmin.listing.toggleListingStatus({ id })

    if (toggleListingStatus.code === 201) {
      await api.userAdmin.notification.create({
        notification: title + ' status is marked ' + (toggleListingStatus.payload.status ? 'public' : 'private'),
        redirect: Encrypt({ path: urlLocation.pathname })
      })

      setAdStatus(toggleListingStatus.payload.status)
      setAdStatusInfo(toggleListingStatus.payload.status ? 'active' : 'inactive')
      adStatus ? Alert.warn(title + ' is marked private') : Alert.success(title + ' is marked public')
    } else {
      Alert.error(toggleListingStatus.message)
    }
    processing.current = false
  }

  const queryHandler = async (id = '', fkUserId = '', query = '', isBusinessOnly = false) => {
    if (processing.current) return
    processing.current = true

    const createLead = isBusinessOnly
      ? await api.publicApi.businessLeads.create({
          contactPerson: userData.name,
          phoneNo: userData.phoneNo,
          email: userData.email,
          query,
          state: userData.state,
          city: userData.city,
          fkBusinessId: id
        })
      : await api.publicApi.leads.create({
          contactPerson: userData.name,
          phoneNo: userData.phoneNo,
          email: userData.email,
          query,
          state: userData.state,
          city: userData.city,
          fkListingId: id
        })

    if (createLead.code === 201) {
      await api.publicApi.notifications.create({
        notification: 'New query from ' + userData.name + ' ' + query,
        fkUserId,
        redirect: ''
      })

      Alert.success('Your interest has been sent!')
    }

    processing.current = false
  }

  const viewMoreHandler = e => {
    e.stopPropagation()
    if (!userData) {
      Modal.PrivacyModal()
      return
    }
    if (userData.plan === 'Plan 0') {
      Modal.Confirm('You need to buy a plan to use this feature', () => navigate('/renewPlan'))
      return
    }
    navigate('/' + location + '/' + Encrypt({ fkBusinessId: fkBusinessId || id }))
  }

  return (
    <div className={s.main}>
      <div
        className={s.adCard}
        onClick={() => {
          if (!!userData) {
            if (userData.plan !== 'Plan 0') {
              navigate(
                '/' + location + '/' + Encrypt({ fkBusinessId: fkBusinessId || id })
              )
            } else Modal.Confirm('You need to buy a plan to use this feature', () => navigate('/renewPlan'))
          } else Modal.PrivacyModal()
        }}
      >
        <div className={s.topCard}>
          <div className={s.left}>
            <div className={s.image}>
              <ImageTag src={image} alt='' />
            </div>
          </div>
          <div className={s.right}>
            <div>
              <div className={s.adTitle}>{title}</div>
              <div className={s.badge} title='Business Type'>
                {engagementType || 'B2C'}
              </div>
              {businessName && (
                <div className={s.businessName + ' ellipsis'} style={{ WebkitLineClamp: '1' }}>
                  ~{businessName}
                </div>
              )}
              {address && (
                <div className={s.address}>
                  <span className='material-icons-outlined' style={{ fontSize: '0.9rem' }}>location_on</span>
                  {address}
                </div>
              )}
              <div className={s.adInfo + ' ellipsis'} style={{ WebkitLineClamp: '4' }}>
                {adInfo}
              </div>
            </div>

            <div className={s.adInteractions} onClick={e => e.stopPropagation()}>
              <div
                className={s.phoneNo}
                onClick={async () => {
                  if (!!userData) {
                    if (userData.plan !== 'Plan 0') {
                      await queryHandler(fkBusinessId ? id : id, fkUserId, 'Queried via call!!', !fkBusinessId)
                      window.location.href = `tel:+91-${phoneNo}`
                    } else Modal.Confirm('You need to buy a plan to use this feature', () => navigate('/renewPlan'))
                  } else Modal.PrivacyModal()
                }}
              >
                <span className='material-icons-outlined'>call</span>
                Call Us
              </div>
              <div
                className={s.whatsapp}
                onClick={async () => {
                  if (!!userData) {
                    if (userData.plan !== 'Plan 0') {
                      await queryHandler(fkBusinessId ? id : id, fkUserId, 'Queried via whatsapp!!', !fkBusinessId)
                      window.open('https://wa.me/91' + phoneNo, '_blank')
                    } else Modal.Confirm('You need to buy a plan to use this feature', () => navigate('/renewPlan'))
                  } else Modal.PrivacyModal()
                }}
              >
                <div className={s.icon}>
                  <img src={images.whatsapp} alt='' />
                </div>
                whatsapp
              </div>
              <div
                className={s.sendInterest}
                onClick={() => {
                  if (!!userData) {
                    if (userData.plan !== 'Plan 0') Modal.QueryForm('', id, fkUserId)
                    else Modal.Confirm('You need to buy a plan to use this feature', () => navigate('/renewPlan'))
                  } else Modal.PrivacyModal()
                }}
              >
                <span className='material-icons-outlined'>send</span>
                send interest
              </div>
              <div className={s.viewMore} onClick={viewMoreHandler}>
                view more <span className='material-icons-outlined'>arrow_drop_down</span>
              </div>
            </div>
          </div>
        </div>
        <div className={s.bottomCard} style={{ paddingTop: '1rem' }}>
          <div className={s.adInteractions} onClick={e => e.stopPropagation()}>
            <div
              className={s.phoneNo}
              onClick={async () => {
                if (!!userData) {
                  if (userData.plan !== 'Plan 0') {
                    await queryHandler(id, fkUserId, 'Queried via call!!')
                    window.location.href = `tel:+91-${phoneNo}`
                  } else Modal.Confirm('You need to buy a plan to use this feature', () => navigate('/renewPlan'))
                } else Modal.PrivacyModal()
              }}
            >
              <span className='material-icons-outlined'>call</span>
              Call Us
            </div>
            <div
              className={s.whatsapp}
              onClick={async () => {
                if (!!userData) {
                  if (userData.plan !== 'Plan 0') {
                    await queryHandler(id, fkUserId, 'Queried via whatsapp!!')
                    window.open('https://wa.me/91' + phoneNo, '_blank')
                  } else Modal.Confirm('You need to buy a plan to use this feature', () => navigate('/renewPlan'))
                } else Modal.PrivacyModal()
              }}
            >
              <div className={s.icon}>
                <img src={images.whatsapp} alt='' />
              </div>
              whatsapp
            </div>
            <div
              className={s.sendInterest}
              onClick={() => {
                if (!!userData) {
                  if (userData.plan !== 'Plan 0') Modal.QueryForm('', id, fkUserId)
                  else Modal.Confirm('You need to buy a plan to use this feature', () => navigate('/renewPlan'))
                } else Modal.PrivacyModal()
              }}
            >
              <span className='material-icons-outlined'>send</span>
              send interest
            </div>
            <div className={s.viewMore} onClick={viewMoreHandler}>
              view more <span className='material-icons-outlined'>arrow_drop_down</span>
            </div>
          </div>
        </div>
      </div>
      {isAdmin && (
        <div className={s.adminControls}>
          <div className={s.adminButtons}>
            <div
              className={s.statusButton}
              onClick={statusHandler}
              style={{
                backgroundColor: adStatus ? 'var(--c-success)' : 'var(--c-warning)',
                color: 'white'
              }}
            >
              {adStatusInfo}
            </div>
            <div
              className={s.deleteButton}
              onClick={() => {
                Modal.Confirm('Are you sure you want to delete this listing?', () => deleteHandler(id))
              }}
              style={{ backgroundColor: 'var(--c-error)', color: 'white' }}
            >
              Delete
            </div>
          </div>
          <div className={s.adminStats}>
            <div>Views: {views}</div>
            <div>Leads: {leads}</div>
            <div>Posted: {new Date(postedOn).toLocaleDateString()}</div>
          </div>
          {rejectionMessage && (
            <div className={s.rejectionMessage}>
              <strong>Rejection Reason:</strong> {rejectionMessage}
            </div>
          )}
        </div>
      )}
    </div>
  )
})

// PropTypes for type validation
AdCard.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  address: PropTypes.string,
  adInfo: PropTypes.string,
  businessName: PropTypes.string,
  phoneNo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isAdmin: PropTypes.bool,
  views: PropTypes.number,
  status: PropTypes.string,
  isActive: PropTypes.bool,
  isApproved: PropTypes.bool,
  leads: PropTypes.number,
  postedOn: PropTypes.string,
  fkUserId: PropTypes.string,
  fkBusinessId: PropTypes.string,
  rejectionMessage: PropTypes.string,
  deleteHandler: PropTypes.func,
  engagementType: PropTypes.string
}

AdCard.defaultProps = {
  image: '',
  address: '',
  adInfo: '',
  businessName: '',
  phoneNo: '',
  isAdmin: false,
  views: 0,
  status: 'active',
  isActive: true,
  isApproved: true,
  leads: 0,
  postedOn: '',
  fkUserId: '',
  fkBusinessId: '',
  rejectionMessage: '',
  deleteHandler: () => {},
  engagementType: ''
}

export default AdCard
